export const filterEUCountries = (countries = []) => {
  return countries.filter(({ isEU }) => {
    return !!isEU;
  });
};

export const getEntryPortCountryCode = (entryPorts, portId) => {
  // find name of port matching portId
  const arrivalPortName = entryPorts?.find((port) => parseInt(port.key) === parseInt(portId))?.value;

  // port names are in the format 'Port Name (GB12345)' where GB is country code
  const arrivalPortCountry = arrivalPortName?.match(/\(([^()]*)\)\s*$/)?.[1]?.substring(0, 2);

  return arrivalPortCountry || 'N/A';
};
